export enum EnumGender {
    Male = 'Male',
    Female = 'Female',
}
export const EnumGenderResourceKey = 'planning.enumGender';
